/// <amd-module name="Core/Medius.Core.Web/Scripts/components/sendEmailDialog/errorItem"/>
import { FlexLayout, IconStatusErrorRegular, Text } from "@medius/ui-controls";
import * as React from "react";

export const ErrorItem = (props: {errorMessage: string}) => {
    return (
        <FlexLayout
            itemColumnSpacing="vsmall"
            wrapItems={false}
            verticalAlignment="top"
        >
            <IconStatusErrorRegular color="error" />
            <Text
                variant="small"
                feedbackType="error"
            >
                {props.errorMessage}
            </Text>
        </FlexLayout>
    );
};
